<template>
    <div class="container">
        <div class="row course-display" style="margin-top: 45px;">
            <div class="col-lg-3">
                <h2>Courses</h2>
                <ul class="chapters">
                    <li>
                        <a :href="courses[0].path">
                            {{courses[0]["menu-title"]}}
                        </a>
                    </li>
                    <li v-for="chapter in chapters" :key="chapter.path">
                        <span class="chapter-title">{{chapter.title}}</span>
                        <ul>
                            <li v-for="link in courses.filter(c => c.chapter === chapter.title)" :key="link.path">
                                <a :href="link.path">
                                    {{link["menu-title"]}}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-lg-9 course-content">
                <h1 style="font-size: 40px;">{{ course.title }}</h1>
                <article>
                    <nuxt-content :document="course" />
                </article>
            </div>
        </div>
    </div>
</template>

<style>
    .col-lg-3 ul {
        list-style-type: none;
        padding-left: 10px;
    }
    
    .chapters > li + li {
        margin-top: 10px;
    }

    .chapter-title {
        font-size: 16px;
    }

    /* we display .katex-mathml since mathjax is prettier. Hide this one */
    .katex-html {
        display: none;
    }
    
    .course-content h2 {
        font-size: 32px;
    }
</style>

<script>
import createHeader from "../../js/meta.js";
import GoalLinkVue from "../../components/goalLink.vue"

export default {
    components: {
        agoal: GoalLinkVue
    },
    async asyncData({ $content, params, error, redirect }) {
        console.log("slug: #" + params.slug + "#");
        if (!params.slug) {
            try {
                const chapters = await $content("courses/chapters")
                    .sortBy("order", "asc")
                    .fetch();

                const courses = await $content("courses")
                    .sortBy("order", "asc")
                    .fetch();

                // if we just went on the "/courses" url, redirect to the first course
                redirect(courses[0].path);
            } catch (e) {
                console.log(e);

                error({
                    statusCode: 404,
                    message: e.toString(),
                });
            }
        } else {
            try {
                const course = await $content("courses", params.slug).fetch();
                console.log(course);
                const courses = await $content("courses").sortBy("order", "asc").fetch();

                const chapters = await $content("courses/chapters")
                    .sortBy("order", "asc")
                    .fetch();

                return {
                    course: course,
                    courses: courses,
                    chapters: chapters
                };
            } catch (e) {
                error({
                    statusCode: 404,
                    message: "This course doesn't exist",
                });
            }
        }
    },
    head() {
        let head = createHeader({
            title: this.course.title,
            description: this.course.description,
            imageUrl: this.course.img,
        });

        return head;
    },
    mounted() {
        // interpret all mathjax when mounted
        //MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
    }
};
</script>
